/**
 * analyticsConsent.jsと連携し、AdobeAnalyticsの計測機能を管理する
 * - Cookie同意状態に基づくAdobeAnalytics計測の有効/無効管理
 * - AdobeAnalytics初期化前のイベントを保存し、初期化後に実行
 * - ページビューやクリックイベントはこのHelperを通して実行する
 */
class AnalyticsHelper {
    constructor() {
        this.pendingEvents = [];
        this.initialized = false;

        // analyticsConsentからのイベントをリッスン
        this.setupAnalyticsListener();

        // 初期状態をチェック
        this.checkInitialState();
    }

    /**
     * analyticsConsent.jsからのAnalyticsReadyイベントをリッスン
     * 計測のための同意取得とスクリプト読み込みが完了した際に発火
     */
    setupAnalyticsListener() {
        try {
            window.addEventListener('AnalyticsReady', () => {
                this.initialized = true;
                this.processPendingEvents();
            });
        } catch (error) {
            console.error('Failed to setup Analytics listener:', error);
        }
    }

    /**
     * Cookie同意、スクリプト読み込みの初期状態を設定
     */
    checkInitialState() {
        try {
            // CookieScriptが不要な環境
            if (!document.getElementById('analytics-consent')) {
                this.initialized = true;
                return;
            }

            // すでにAnalyticsが読み込まれている場合は初期化済みとする
            if (typeof window.s !== 'undefined' && typeof window.s.t === 'function') {
                this.initialized = true;
                this.processPendingEvents();
            }
        } catch (error) {
            console.error('Error checking initial state:', error);
        }
    }

    /**
     * 保留中のイベントを処理
     */
    processPendingEvents() {
        if (!this.pendingEvents.length || !this.initialized) return;

        try {
            const events = [...this.pendingEvents];
            this.pendingEvents = [];

            events.forEach(event => {
                try {
                    event();
                } catch (error) {
                    console.error('Error executing pending event:', error);
                }
            });
        } catch (error) {
            console.error('Error processing pending events:', error);
        }
    }

    /**
     * 計測実行
     * @param {Function} trackingCallback 計測処理コールバック関数
     */
    trackEvent(trackingCallback) {
        if (!trackingCallback || typeof trackingCallback !== 'function') return;

        if (!this.initialized) {
            // 初期化前の場合は保留リストに追加
            this.pendingEvents.push(trackingCallback);
            return;
        }

        // 初期化済みの場合は即時実行
        try {
            trackingCallback();
        } catch (error) {
            console.error('Error tracking event:', error);
        }
    }
}

const analyticsHelper = new AnalyticsHelper();
export default analyticsHelper;
